module.exports = __webpack_public_path__ + "img/video_thumb.f321e1a0.jpg";